import { routeCreator } from "../helpers/routing/routeCreator";
import Home from "../pages/home/home.jsx";
// import Login from "../pages/login/login.jsx";
import NotFound from "../pages/notFound/notFound";
import TestPage from "../pages/testPage/testPage";
import Dashboard from "../pages/account/dashboard";
import AddressEdit from "../pages/account/addressEdit";
import Coupons from "../pages/account/coupons";
import Details from "../pages/account/details";
import Addresses from "../pages/account/myAddresses";
import Order from "../pages/account/order";
import OrderHistory from "../pages/account/orderHistory";
import Cart from "../pages/cart/cart";
import Checkout from "../pages/checkOut/checkOut";
import ExtraPage from "../pages/company/extraPage";
import ShippingWays from "../pages/company/shippingWays";
import ThankYou from "../pages/thankYou/thankYou";
import Returns from "../pages/account/returns";
import SingleProduct from "../pages/products/singleProduct";
import About from "../pages/company/aboutUs/about";
import ProductsIndex from "../pages/products/productsIndex";
import OnlinePaymentsSuccess from "../pages/onlinePayments/onlinePaymentsSuccess";
import OnlinePaymentsFailure from "../pages/onlinePayments/onlinePaymentsFailure";
import OnlinePaymentsCancel from "../pages/onlinePayments/onlinePaymentsCancel";

export const ROUTE_PAGE_HOME = routeCreator(Home, "/", "home", "page.home", {exact: true,});
export const ROUTE_PAGE_TEST = routeCreator(TestPage, "/test", "test", "page.test", { exact: true });
export const ROUTE_NOT_FOUND = routeCreator(NotFound, "/not-found", "notFound", "page.notFound", { exact: true });
//account
export const ROUTE_DASHBOARD = routeCreator(Dashboard, "/account/dashboard", "dashboard", "page.dashboard", { exact: true, private: true });
export const ROUTE_ADDRESS_EDIT = routeCreator(AddressEdit, "/account/address/edit/:id", "addressEdit", "page.addressEdit", { exact: true, private: true });
export const ROUTE_ADDRESS_CREATE = routeCreator(AddressEdit, "/account/address/create", "addressCreate", "page.addressCreate", { exact: true, private: true });
export const ROUTE_COUPONS = routeCreator(Coupons, "/account/coupons", "coupons", "page.coupons", { exact: true, private: true });
export const ROUTE_DETAILS = routeCreator(Details, "/account/details", "details", "page.details", { exact: true, private: true });
export const ROUTE_ADDRESSES = routeCreator(Addresses, "/account/addresses", "addresses", "page.addresses", { exact: true, private: true });
export const ROUTE_ORDER_HISTORY = routeCreator(OrderHistory, "/account/order/history", "orderHistory", "page.orderHistory", { exact: true, private: true });
export const ROUTE_RETURNS = routeCreator(Returns, "/account/returns", "returns", "page.returns", { exact: true, private: true });

export const ROUTE_ORDER = routeCreator(Order, "/order/:id", "order", "page.order", { exact: true, private: true });

export const ROUTE_CHECKOUT = routeCreator(Checkout, "/checkout", "checkout", "page.checkout", { exact: true, private: true });
//cart
export const ROUTE_CART = routeCreator(Cart, "/cart", "cart", "page.cart", {exact: true,});
//company
export const ROUTE_ABOUT_US = routeCreator(About, "/aboutUs", "aboutUs", "page.aboutUs", { exact: true });
export const ROUTE_EXTRA_PAGE = routeCreator(ExtraPage, "/extraPage", "extraPage", "page.extraPage", { exact: true });
export const ROUTE_SHIPPING_WAYS = routeCreator(ShippingWays, "/shipping/ways", "shippingWays", "page.shippingWays", { exact: true });
//products
export const ROUTE_PRODUCT_LIST = routeCreator(ProductsIndex, "/products", "products", "page.products", { exact: true });
export const ROUTE_SINGLE_PRODUCT = routeCreator(SingleProduct, "/product/:id", "product", "page.product", { exact: true });
//thank you
export const ROUTE_THANK_YOU = routeCreator(ThankYou, "/thankYou", "thankYou", "page.thankYou", { exact: true });
export const ROUTE_ONLINE_PAYMENTS_SUCCESS = routeCreator(OnlinePaymentsSuccess, "/onlinePayments/success", "onlinePaymentsSuccess", "page.onlinePaymentsSuccess");
export const ROUTE_ONLINE_PAYMENTS_FAILURE = routeCreator(OnlinePaymentsFailure, "/onlinePayments/failure", "onlinePaymentsFailure", "page.onlinePaymentsFailure");
export const ROUTE_ONLINE_PAYMENTS_CANCEL = routeCreator(OnlinePaymentsCancel, "/onlinePayments/cancel", "onlinePaymentsCancel", "page.onlinePaymentsCancel");


const router = {
  ROUTE_PAGE_HOME,
  ROUTE_PAGE_TEST,
  ROUTE_NOT_FOUND,
  ROUTE_DASHBOARD,
  ROUTE_ADDRESS_EDIT,
  ROUTE_ADDRESS_CREATE,
  ROUTE_COUPONS,
  ROUTE_DETAILS,
  ROUTE_ADDRESSES,
  ROUTE_ORDER,
  ROUTE_ORDER_HISTORY,
  ROUTE_CART,
  ROUTE_CHECKOUT,
  ROUTE_ABOUT_US,
  ROUTE_EXTRA_PAGE,
  ROUTE_SHIPPING_WAYS,
  ROUTE_PRODUCT_LIST,
  ROUTE_SINGLE_PRODUCT,
  ROUTE_THANK_YOU,
  ROUTE_RETURNS,
  ROUTE_ONLINE_PAYMENTS_SUCCESS,
  ROUTE_ONLINE_PAYMENTS_FAILURE,
  ROUTE_ONLINE_PAYMENTS_CANCEL
};

export default router;
